import { RouteConfig } from 'vue-router';

const SzjcFolder = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szjc/szjc-folder.vue');
const Szjc = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szjc/szjc.vue');
const Dxst = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/dxst/dxst.vue');
const Szsx = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szsx/szsx.vue');
const SzsxDetail = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szsx/szsx-detail.vue');
const SzsxReport = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szsx/szsx-report.vue');
const SzsxMoni = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szsx/szsx-moni/szsx-moni.vue');
const SzsxMoniResult = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szsx/szsx-moni-result/szsx-moni-result.vue');
const SzksList = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szks/szks-list.vue');
const SzksDetail = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szks/szks-detail/szks-detail.vue');
const SzksResultList = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szks/szks-result-list/szks-result-list.vue');
const SzksResult = () => import(/* webpackChunkName: "Shezhenjiaoxue" */  './modules/szks/szks-result/szks-result.vue');


const routers: RouteConfig[] = [
    {
        path: 'szjc-folder',
        component: SzjcFolder
    },
    {
        path: 'szjc',
        component: Szjc
    },
    {
        path: 'dxst',
        component: Dxst
    },
    {
        path: 'szsx',
        component: Szsx
    },
    {
        path: 'szsx-detail',
        component: SzsxDetail
    },
    {
        path: 'szsx-report',
        component: SzsxReport
    },
    {
        path: 'szsx-moni',
        component: SzsxMoni
    },
    {
        path: 'szsx-moni-result',
        component: SzsxMoniResult
    },
    {
        path: 'szks-list',
        component: SzksList
    },
    {
        path: 'szks-detail',
        component: SzksDetail
    },
    {
        path: 'szks-result-list',
        component: SzksResultList
    },
    {
        path: 'szks-result',
        component: SzksResult
    },
    {
        path: '',
        redirect: 'szjc-folder'
    },
];

export default routers;
